// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { OptionCardUtils_WouldDeselectFragmentDoc } from './optionCardUtils.generated';
export type ExteriorOptionCard_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, group: { __typename?: 'ReadyPlanOptionGroup', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean } } }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, totalCostInCents: number, canBeSelected: { __typename?: 'PotentialOperation2', allowed: boolean }, wouldDeselect: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isSingleOptionGroup: boolean } }>, option: { __typename?: 'ReadyPlanOption', id: string, name: string, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }, rendering?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }> };

export const ExteriorOptionCard_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment ExteriorOptionCard_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  group {
    id
    group {
      id
      type {
        id
        isElevation
        isExteriorScheme
      }
    }
  }
  options {
    id
    totalPriceInCents
    totalCostInCents
    canBeSelected {
      allowed
    }
    wouldDeselect {
      ...OptionCardUtils_WouldDeselect
    }
    option {
      id
      name
      optionImage {
        id
        previewUrl(resizing: {width: 192, region: SQUARE})
      }
    }
    rendering {
      id
      previewUrl(resizing: {width: 192, region: SQUARE})
    }
  }
}
    ${OptionCardUtils_WouldDeselectFragmentDoc}`;